import React, { PureComponent } from 'react'
import { SOURCE_STRINGS } from '../../../constants'
import NewsFeedInfo from './StyledNewsFeedInfo'
import NewsFeedItem from './NewsFeedItem'

class NewsFeedItemArticle extends PureComponent {
  constructor (props) {
    super(props)
    this.handleAnchorClick = this.handleAnchorClick.bind(this)
  }

  isGoogleAnalyticsSet () {
    return typeof this.props.googleAnalytics !== 'undefined'
  }

  handleAnchorClick (event, location) {
    event.preventDefault()

    const {
      box: {
        guid: id,
        title: name,
        gaCategory: category
      },
      googleAnalytics
    } = this.props

    const purchaseFieldObject = {
      id,
      name,
      category
    }

    if (this.isGoogleAnalyticsSet()) {
      googleAnalytics.handlePurchaseEvent(purchaseFieldObject).then(() => {
        document.location.href = location
      }).catch(() => {
        document.location.href = location
      })
    } else {
      document.location.href = location
    }
  }

  render () {
    const {
      box,
      box: {
        source,
        category
      }
    } = this.props

    return (
      <NewsFeedItem handleAnchorClick={this.handleAnchorClick} {...box}>
        <NewsFeedInfo source={source}>
          {SOURCE_STRINGS[source]}
          {
            category &&
            ` | ${category}`
          }
        </NewsFeedInfo>
      </NewsFeedItem>
    )
  }
}

export default NewsFeedItemArticle
